import React from "react"
import { BreakpointsProvider } from "./lib/hooks/use-breakpoints"

const wrapPageElement = ({ element, props }) => {
  return <BreakpointsProvider>{element}</BreakpointsProvider>
}

export default wrapPageElement
